/**
 * Edit Network Site Form Composer
 *
 * Reuses AddNetworkSiteComposer with initialValues for edit mode.
 * Submit label comes from form.yml configuration.
 */

import { AddNetworkSiteComposer, type AddNetworkSiteComposerProps } from '../addNetworkSite/composer'
import type { AddNetworkSiteFormData } from '../addNetworkSite/schema'
import { FORM_CONFIG } from './schema'

export type EditNetworkSiteComposerProps = Omit<
  AddNetworkSiteComposerProps,
  'initialValues'
> & {
  networkSiteNumber: number
  initialValues: Omit<AddNetworkSiteFormData, 'networkSiteNumber'>
  submitLabel?: string
}

export function EditNetworkSiteComposer(props: EditNetworkSiteComposerProps) {
  const { networkSiteNumber, initialValues, ...rest } = props

  return (
    <AddNetworkSiteComposer
      {...rest}
      initialValues={{
        ...initialValues,
        networkSiteNumber,
      }}
      networkSiteNumber={networkSiteNumber}
      submitLabel={props.submitLabel ?? FORM_CONFIG.submitButton?.label ?? 'Save Network Site'}
    />
  )
}

